/* eslint-disable */
// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";


const initialUser = () => {
  const item = window.localStorage.getItem("userData");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {};
};  

export const authSlice = createSlice({
  name: "authentication",
  initialState: {
    user: initialUser(),
    notiCount: 0,
  },
  reducers: {
    handleLogin: (state, action) => {
      const payload = action.payload || {};
      const safeUser = payload.user ? { ...payload.user } : payload.user;
      if (safeUser) delete safeUser.password;
      const safePayload = { ...payload, user: safeUser };
      state.user = safePayload;
      

      //state[config.storageTokenKeyName] =
      // action.payload[config.storageTokenKeyName];

      localStorage.setItem("userData", JSON.stringify(safePayload));

      // localStorage.setItem(
      //   config.storageTokenKeyName,
      //   JSON.stringify(action.payload.accessToken)
      // );
    },
    handleLogout: (state) => {
      state.userData = {};
      state.user = {};

      // state[config.storageRefreshTokenKeyName] = null;
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem("userData");
      // localStorage.removeItem(config.storageTokenKeyName);
      // localStorage.removeItem(config.storageRefreshTokenKeyName);
    },

    handleUserDetails: (state, action) => {
      state.user.fullName = action?.payload?.fullName;
    },
    handleAuth: (state, action) => {

      state.user.accessToken = action?.payload?.accessToken;
      state.user.refreshToken = action?.payload?.refreshToken;

    },
    addNotiCount: (state, action) => {
      state.notiCount = action.payload;
    },
  },
});

export const { handleLogin, handleLogout, handleUserDetails, handleAuth, addNotiCount } = authSlice.actions;

export default authSlice.reducer;
